import { useMutation } from "@tanstack/react-query";
import estimateProvider from "@/providers/estimate.provider";
import type { IMissingMapping } from "@/interfaces/payloads/xactimate";

const VALIDATE_XACTIMATE_EXPORT_KEY = ["xactimateExport", "validate"] as const;

export interface ValidateXactimateExportResult {
  missingFields: string[];
  missingMappings: IMissingMapping[];
}

export function useValidateXactimateExportMutation() {
  return useMutation({
    mutationKey: VALIDATE_XACTIMATE_EXPORT_KEY,
    mutationFn: async (estimateId: string): Promise<ValidateXactimateExportResult> => {
      const response = await estimateProvider.validateXactimateExport(estimateId);
      if (!response.success) {
        throw new Error("Failed to validate Xactimate export");
      }
      return {
        missingFields: response.data?.missingFields ?? [],
        missingMappings: response.data?.missingMappings ?? [],
      };
    },
  });
}
